<template>
  <section :class="sectionClass">
    <LayoutContainer
      v-for="(item, i) in items"
      :key="i"
      :type="item.type"
      :slices="item.slices"
      :section-index="sectionIndex"
    />
  </section>
</template>

<script lang="ts" setup>
import { type Container as SlicesContainer, SectionType } from './types'
import LayoutContainer from './layout-container.vue'

const props = defineProps<{
  items: SlicesContainer[]
  type: SectionType
  sectionIndex: number
}>()

const sectionClass = computed(() => {
  switch (props.type) {
    case SectionType.SIDEBAR:
      return 'md:container grid gap-6 lg:grid-cols-sidebar'
    case SectionType.VERTICAL_BOX:
      return 'md:container grid gap-6'
    case SectionType.VERTICAL_FREE:
      return 'container grid gap-6'
    case SectionType.FLUID:
    default:
      return 'grid gap-6'
  }
})
</script>
